<template lang="pug">

.base-bloco-totalizador
    .container-card
        .container-img
            img(:src='buscarUrlImagem(icone)')
        .container-body
            span.base-bloco-totalizador-titulo {{ etapa }} cadastradas {{ periodo }}
            .base-bloco-totalizador__interno
                span.base-bloco-totalizador__interno-numero {{numero}}
                span.base-bloco-totalizador__interno-texto Última atualização: {{ data !== 'null' ?  data : '--/--/--' }}
</template>

<script>
import { integer } from 'vuelidate/lib/validators';

export default {
    name: 'BaseCardTotalizadorRastreabilidade',
    props: {
        etapa: {
            type: String,
            default: () => ''
        },
        texto: {
            type: String,
            default: () => ''
        },
        numero: {
            type: integer,
            default: () => ''
        },
        data: {
            type: String,
            default: () => ''
        },
        icone: {
            type: String,
            default: () => ''
        }
    },
    computed: {

        periodo: function () {
            switch (this.texto) {
                case 'Diário':
                    return 'hoje';
                case 'Semanal':
                    return 'na semana';
                case 'Mensal':
                    return 'no mês';
                default:
                    break;
            }
            return '';
        }
    },
    data() {
        return {};
    },
    methods: {
        buscarUrlImagem(nome) {
            return require(`@/assets/raizen-icons/rastreabilidade/${nome}.png`);
        }
    }
};
</script>

<style lang="scss" scoped>

.container-card {
    display: flex;
    gap: 27px;
}

.container-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 5px;
}

.container-img {
    align-self: center;
}
 
.base-bloco-totalizador {
    background: var(--white);
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 89px;
    color: var(--primary);
    flex-wrap: wrap;
    box-shadow: 0px 0px 2px 0px var(--block-shadow);
    gap: 3px;

    .base-bloco-totalizador-titulo {
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        color:#3B3B3B;
    }
    .base-bloco-totalizador__interno {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 40px;

        .lyra-icon::before {
            content: '';
            width: 28px !important;
            height: 25px !important;
            background-color: var(--primary) !important;
        }
        .mdi::before {
            font-size: 26px !important;
            color: var(--primary) !important;
        }
    }
    .base-bloco-totalizador__interno-numero {
        flex-wrap: wrap;
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        color: #00413C;
    }
    span {
        padding: 3px;
        &.base-bloco-totalizador__interno-texto {
            font-weight: 400;
            font-size: 14px;
            line-height: 16px;
            color: #3B3B3B;
        }
    }

    &:first-child {
        margin: 2px 3px 2px 0px;
    }

    &:not(:first-child) {
        margin: 2px 3px 2px 2px;
    }
}
@media only screen and (max-width: 1334px) {
    .base-bloco-totalizador {
        min-width: 48% !important;
    }
}
</style>
